"use client";
import React, { useState } from "react";
import "./footer.css";
import Link from "next/link";

function Footer() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const closeBookingModal = () => setIsBookingOpen(false);
  const openBookingModal = () => setIsBookingOpen(true);
  return (
    <footer className="footer-container">
      {isBookingOpen && (
        <div className="booking-Pop-cont">
          <button className="close" onClick={closeBookingModal}>
            &times;
          </button>
          <h2>MAKE THE BEST OF YOUR BENEFITS</h2>
          <div className="booking-card-cont">
            <div className="booking-card">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=hotels`}
                target="_blank"
              >
                <img
                  src="/images/Holidays-Hotels-Book.png"
                  alt="Holidays Hotels & Resorts"
                />
                <p>Holidays Hotels & Resorts</p>
              </Link>
            </div>
            <div className="booking-card">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=hotels`}
                target="_blank"
              >
                <img
                  src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Cruises-Book.png"
                  alt="Cruises"
                />
                <p>Cruises</p>
              </Link>
            </div>
            <div className="booking-card">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=flights`}
                target="_blank"
              >
                <img
                  src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Flights-Book.png"
                  alt="Flights"
                />
                <p>Flights</p>
              </Link>
            </div>
            <div className="booking-card">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=cars`}
                target="_blank"
              >
                <img src="/images/Car-Hire-Book.png" alt="Car Hire" />
                <p>Car Hire</p>
              </Link>
            </div>
            <div className="booking-card">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=tours-activities`}
                target="_blank"
              >
                <img
                  src="/images/Tours-Activities-Book.png"
                  alt="Tours & Activities"
                />
                <p>Tours & Activities</p>
              </Link>
            </div>
            {/* <div className="booking-card">
                <Link href="/" target="_blank">
                  <img src="" alt="Personal Development"/>
                  <p>Personal Development</p>
                </Link>
              </div> */}
            <div className="booking-card card-overlay">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=dining-coffee`}
                target="_blank"
              >
                <div className="iao-overlay-cont">
                  <img
                    src="/images/Dining-Coffee-Book.png"
                    alt="Dining & Coffee"
                  />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Dining & Coffee</p>
              </Link>
            </div>
            <div className="booking-card card-overlay">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=movies`}
                target="_blank"
              >
                <div className="iao-overlay-cont">
                  <img src="/images/Movies-Book.png" alt="Movies" />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Movies</p>
              </Link>
            </div>
            <div className="booking-card card-overlay">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=spa`}
                target="_blank"
              >
                <div className="iao-overlay-cont">
                  <img src="/images/Spa-Book.png" alt="Spa" />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Spa</p>
              </Link>
            </div>
            <div className="booking-card card-overlay">
              <Link
                href={`https://test-firstloyaltyplus.leisureloyalty.com/${
                  typeof window !== "undefined" &&
                  window.localStorage.getItem("offbeat-token")
                }/?service=deals-4-u`}
                target="_blank"
              >
                <div className="iao-overlay-cont">
                  <img src="/images/Deals-4-U-Book.png" alt="Deals-4-U" />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Deals-4-U</p>
              </Link>
            </div>
          </div>
        </div>
      )}
      <div className="footer-bg-img"></div>
      <div className="footer-block">
        <div>
          <img
            src="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/off_beat_logo-large.png"
            height="auto"
            alt="Off Beat Logo"
          />
          <img
            className="off-beat-plus-logo"
            src="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/off_beat_logo-PLUS.png"
            height="auto"
            alt="Off Beat Plus Logo"
          />
          <p>
            Customer Care<br></br>
            <a href="tel:0123492277" target="_blank">
              +27 (012) 349 2277
            </a>
            <br></br>
            <br></br>
            Email us on<br></br>
            <a
              href="mailto:offbeatreservations@clubleisure.co.za"
              target="_blank"
            >
              offbeatreservations@clubleisure.co.za
            </a>
            <br></br>
            <br></br>
            <a href="tel:0317177592" target="_blank">
              +27 (0)31 717 7592
            </a>
            <br></br>
            <a
              href="mailto:internationalres@holidaygateway.co.za"
              target="_blank"
            >
              internationalres@holidaygateway.co.za
            </a>
            <br></br>
            <br></br>
            Admin Offices<br></br>
            <a href="tel:0123491433" target="_blank">
              +27 (012) 349 1433
            </a>
            <br></br>
            Eulophia Corner, 2 Quintin Brand Street,<br></br>
            Persequor Park, Pretoria 0020<br></br>
            <br></br>
          </p>
        </div>
        <div>
          <ul>
            <li>
              <span>Off beat holiday club</span>
            </li>
            <li>
              <Link href="/about">About us</Link>
            </li>
            <li>
              <Link href="/off-beat-membership-benefits">
                Memberships & Benefits
              </Link>
            </li>
            <li>
              <Link href="/off-beat-holiday-club">Club Rules</Link>
            </li>
            <li>
              <Link target="_blank" href="https://fgcdn.azureedge.net/cope/Member_Documents/OBHC%20AGM%20Pack%202026.pdf">Off Beat Holiday Club AGM 2026</Link>
            </li>
            <li>
              <Link target="_blank" href="https://fgcdn.azureedge.net/cope/Member_Documents/OBHC%20AFS%202026.pdf">Off Beat Holiday Club AFS 2026</Link>
            </li>
            <li>
              <Link target="_blank" href="https://fgcdn.azureedge.net/cope/Member_Documents/OffbeatHC%20Stop%20Order%20R40.pdf">Off Beat Holiday Club Stop Order</Link>
            </li>
            <br></br>
            <li>
              <span>Off beat plus</span>
            </li>
            <li>
              <Link href="/terms-of-service">
                Membership Terms and Conditions
              </Link>
            </li>
            <br></br>
            <li>
              <span>General</span>
            </li>
            <li>
              <Link href="/privacy-policy">Website Privacy Policy</Link>
            </li>
            <li>
              <Link href="/terms-of-service">Website Terms Of Service</Link>
            </li>
            {/* <li>
              <Link
                href="https://fgcdn.azureedge.net/cope/Competitions/9528_Cruise%20Page%20Ts%20Cs%20v3_JN.pdf"
                target="_blanks"
              >
                Competition Rules
              </Link>
            </li> */}
            <br></br>
            <br></br>
            <span>
              Off Beat PLUS is managed by First Group<br></br>
              <Link href="tel:+27317177660">+27 (0) 31 717 7660</Link>
            </span>
          </ul>
        </div>
        <div>
          <div id="footer-btn" className="foot-btn-cont">
            <Link href="/contact">
              <button className="book">Contact us</button>
            </Link>
            <Link href="/join-now">
              <button className="join">Join Now</button>
            </Link>
            <Link href="/register">
              <button className="register">Register</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-subtext">
        <p>
          © 2024 Off Beat Holiday Club and Off Beat PLUS. All Rights Reserved
          <br />
          Off Beat Holiday Club and Off Beat PLUS are products developed and
          managed by First Group Holdings (Pty) Ltd
          <br />
          <br />
          The content and images on this site are copyright protected vests with
          the respective entities. The usage of the content and images on this
          website is intended to promote the works and no endorsement and
          ownership of the artist shall be implied. Unauthorised use is
          prohibited and punishable by law.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
